import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getSquadTvExitHintStyles = (theme: Theme) =>
  StyleSheet.create({
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 12,
      alignItems: 'center',
      zIndex: 4,
    },
    chip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      paddingHorizontal: 14,
      paddingVertical: 8,
      borderRadius: 999,
      backgroundColor: theme.black + '8C',
      borderWidth: 1,
      borderColor: theme.white + '22',
      ...(Platform.OS === 'web' && {
        backdropFilter: 'saturate(140%) blur(8px)' as never,
        WebkitBackdropFilter: 'saturate(140%) blur(8px)' as never,
      }),
    },
    hintText: {
      fontSize: 13,
      fontWeight: '600',
      color: theme.white,
    },
    escapeText: {
      fontSize: 12,
      fontWeight: '500',
      color: theme.white + 'B3',
    },
  });
